<template>
    <div>
        <ion-grid>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="search-view">
                <ion-col >
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label>User Role <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select 
                                    v-model="roleId"
                                    class="form-select select-mobile"
                                    placeholder="Select Status"
                                    interface="action-sheet">
                                    <ion-select-option
                                        v-for="role in userRoleOptions"
                                        :key="role.roleId"
                                        :value="role.roleId"
                                    >
                                        {{ role.description }}
                                    </ion-select-option>
                                </ion-select>
                                <select
                                    class="input-select select-web"
                                    v-model="roleId"
                                    placeholder="Select Status"
                                    >
                                    <option
                                    v-for="role in userRoleOptions"
                                        :key="role.roleId"
                                        :value="role.roleId"
                                    >{{ role.description }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>Enter Email Id<span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="emailOrMobile" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>User Name <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="userName" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col>
                        
                        <ion-col size="12" size-md="3">
                            <br />
                            <ion-button class="btn-add btn-search margin-top-10" @click="addUser">{{ isEditing ? "Update" : "Add User" }}</ion-button>
                            <ion-button class="btn-cancel btn-search margin-top-10" @click="cancel">Cancel</ion-button>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            
        </ion-grid>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonLabel, IonRow, IonInput, IonSelect, IonSelectOption } from "@ionic/vue";
import datepicker from 'vue3-datepicker';
import { ToastUtils } from "../../util/toast-utils";
import { AdminService } from "@/service/admin/admin.service";
import { migratedTryParseServiceError } from "../../service";
import { updateUserFromAdmin } from "../../entity/authentication/profile";
import { ValidationUtils } from "../../util/validation-utils";

export default defineComponent({
    name: 'AddNewUser',
    components:{
        IonGrid, IonRow, IonCol, IonButton, IonLabel, IonInput, datepicker, IonSelect, IonSelectOption
    },
    data(){
        return{
            emailOrMobile: "",
            userName: "",
            roleId: "",
            isEditing : false,
            userRoleOptions: ''
        }
    },
    async mounted() {
        this.userRoleOptions = await new AdminService().userRoles("Add");
        this.emailOrMobile = "";
        this.userName = "";
        this.roleId = "";
        this.isEditing = false;

        const isEditing = localStorage.getItem("isEditingUser");
        if (isEditing === "true") {
            const user = JSON.parse(localStorage.getItem("editUserData"));
            this.emailOrMobile = user.emailOrMobile;
            this.userName = user.userName;
            this.roleId = user.roleId;
            this.isEditing = true;
        } else {
            
        }
    },

    methods: {
        async addUser() {
            if (
                typeof this.emailOrMobile === "undefined" ||
                this.emailOrMobile === null ||
                this.emailOrMobile === "" || 
                (this.emailOrMobile).toString().trim().length === 0
            ) {
                new ToastUtils().presentToast("Enter Mobile or Email ID");
            } else if(!new ValidationUtils().email(this.emailOrMobile)) {
                new ToastUtils().presentToast("Enter Valid Email ID");
            } else {
                this.usersAdded();
            }
            // else if(this.roleId == 4) {
            //     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                
            //     if (!emailPattern.test(this.emailOrMobile)) {
            //         new ToastUtils().presentToast("Please enter a valid Email ID");
            //     }  else {
            //         this.usersAdded();
            //     }
            // } else {
            //     const numberPattern = /^[0-9]+$/;

            //     if (!numberPattern.test(this.emailOrMobile)) {
            //         new ToastUtils().presentToast("Please enter numbers only");
            //     } else {
            //         this.usersAdded();
            //     }
            // } 
        },
        
        async usersAdded() {
            try {
                    let result = await new AdminService().addNewUser(
                        this.userName,
                        this.emailOrMobile,
                        this.roleId
                    );

                    if(result?.success) {
                        new ToastUtils().presentToast(result.message);
                    }
                    this.$router.push("CPOUserCreation");
                } catch(error) {
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
        },

        cancel() {
            this.$router.back();
        },
    }
})
</script>

<style scoped>
.container-div{
    /* width: 30%; */
    margin-top: 20px;
    border: 2px solid rgb(240, 236, 236);
    border-radius: 20px;
    box-shadow: 2px 2px rgb(70, 68, 68);
    
}
.usage-txt{
    font-size: 22px;
    text-align: center;
}
.report-list{
    margin: 80px 0 0 0;
}
.edit-payment {
  font-size: 17px;
  /* margin-left: 2px; */
  cursor: pointer;
}
.btn-add {
    --background: #21b24b 0% 0% no-repeat padding-box;
}
.btn-cancel {
    --background: #8c8b8b 0% 0% no-repeat padding-box;
}
</style>